import { Box } from '@chakra-ui/react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts'
import { useChartTheme } from '../../../hooks/useChartTheme'
import CustomTooltip from './CustomTooltip'
import type { DestinationFlow } from '../../../data/mockEstadisticas'

const minerals: { key: keyof Omit<DestinationFlow, 'destino'>; label: string; color: string }[] = [
  { key: 'cobre', label: 'Cobre', color: '#1A7A4C' },
  { key: 'oro', label: 'Oro', color: '#2a8a87' },
  { key: 'hierro', label: 'Hierro', color: '#EAB308' },
  { key: 'zinc', label: 'Zinc', color: '#3d6fa8' },
  { key: 'plata', label: 'Plata', color: '#b5aa9d' },
]

interface DestinationFlowChartProps {
  data: DestinationFlow[]
}

export default function DestinationFlowChart({ data }: DestinationFlowChartProps) {
  const { axis, grid } = useChartTheme()

  const chartData = data.map((d) => ({
    ...d,
    destino: d.destino.length > 15 ? d.destino.slice(0, 15) + '...' : d.destino,
  }))

  return (
    <Box h="320px">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={chartData}>
          <CartesianGrid stroke={grid.stroke} strokeDasharray={grid.strokeDasharray} />
          <XAxis dataKey="destino" stroke={axis.stroke} tick={{ ...axis.tick, fontSize: 10 }} />
          <YAxis stroke={axis.stroke} tick={axis.tick} tickFormatter={(v: number) => `${(v / 1000).toFixed(0)}k`} />
          <Tooltip content={<CustomTooltip formatter={(v) => `${v.toLocaleString()} TM`} />} />
          <Legend wrapperStyle={{ fontSize: 11, fontFamily: "'Instrument Sans', sans-serif" }} />
          {minerals.map((m) => (
            <Bar key={m.key} dataKey={m.key} name={m.label} stackId="stack" fill={m.color} barSize={32} />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </Box>
  )
}
